export function FleetStat({ icon, label, value, sub }) {
  return (
    <div className="bg-white dark:bg-[#1F2937] border border-black/10 dark:border-white/10 p-4 rounded">
      <div className="flex items-center justify-between mb-2">
        <span className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 dark:text-neutral-400">{label}</span>
        <span className="text-neutral-400">{icon}</span>
      </div>
      <p className="font-display text-2xl">{value}</p>
      {sub && <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-1">{sub}</p>}
    </div>
  );
}

export function FormField({ label, children }) {
  return (
    <label className="block">
      <span className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 dark:text-neutral-400 block mb-1">{label}</span>
      {children}
    </label>
  );
}

export function FormInput(props) {
  return (
    <input
      {...props}
      className={`w-full bg-transparent border-b border-black/15 dark:border-white/15 py-2 outline-none focus:border-black dark:focus:border-white transition-colors ${props.className || ""}`}
    />
  );
}

export function FormSelect({ children, ...rest }) {
  return (
    <select
      {...rest}
      className="w-full bg-transparent border-b border-black/15 dark:border-white/15 py-2 outline-none focus:border-black dark:focus:border-white transition-colors"
    >
      {children}
    </select>
  );
}

export function FormTextarea({ children, ...rest }) {
  return (
    <textarea
      {...rest}
      className="w-full bg-transparent border-b border-black/15 dark:border-white/15 py-2 outline-none focus:border-black dark:focus:border-white transition-colors"
    >
      {children}
    </textarea>
  );
}
